import React, { Component } from 'react';
import { Route, Redirect, RouteComponentProps } from 'react-router-dom';
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants';
import authService from './AuthorizeService';

interface Props {
    path: string;
    component: React.ComponentType<any>;
    exact?: boolean;
    location?: RouteComponentProps['location'];
}

interface State {
    ready: boolean;
    authenticated: boolean;
}

export default class AuthorizeRoute extends Component<Props, State> {
    private _subscription: number = 0;

    constructor(props: Props) {
        super(props);
        this.state = { ready: false, authenticated: false };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.authenticationChanged());
        this.populateAuthenticationState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    render() {
        const { ready, authenticated } = this.state;
        const link = document.createElement('a');
        link.href = this.props.path;
        const pathname = this.props.location?.pathname ?? link.pathname;
        const returnUrl = `${link.protocol}//${link.host}${pathname}${link.search}${link.hash}`;
        const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`;

        if (!ready) return <div></div>;

        const { component: RouteComponent, ...rest } = this.props;
        return (
            <Route
                {...rest}
                render={(props) => {
                    if (authenticated) {
                        return <RouteComponent {...props} />;
                    }
                    // Don't redirect if already on an auth path — prevents a race during
                    // logout where notifySubscribers() fires before the page navigates away.
                    if (window.location.pathname.startsWith(ApplicationPaths.ApiAuthorizationPrefix)) {
                        return <div></div>;
                    }
                    return <Redirect to={redirectUrl} />;
                }}
            />
        );
    }

    private async populateAuthenticationState() {
        const authenticated = await authService.isAuthenticated();
        this.setState({ ready: true, authenticated });
    }

    private async authenticationChanged() {
        this.setState({ ready: false, authenticated: false });
        await this.populateAuthenticationState();
    }
}

